// parser.js
function parseDSL(content) {
    if (!content) return [];

    const lines = content.split('\n');
    const lessons = [];
    let currentLesson = null;
    let currentType = '';
    let currentItem = null;
    let pendingTranslations = [];

    function finalizeItem() {
        if (currentItem && pendingTranslations.length > 0) {
            const combinedText = pendingTranslations.join(' ');
            const parts = combinedText.split('|').map(p => p.trim()).filter(p => p.length > 0);

            currentLesson.meta.langs.forEach((lang, index) => {
                if (parts[index]) {
                    currentItem.translations[lang] = parts[index];
                }
            });
            pendingTranslations = [];
        }
    }

    lines.forEach(line => {
        const trimmed = line.trim();
        if (!trimmed) return;

        // 1. Заголовок
        if (trimmed.startsWith('# Title:')) {
            finalizeItem();
            if (currentLesson) lessons.push(currentLesson);
            currentLesson = {
                title: trimmed.replace('# Title:', '').trim(),
                meta: { langs: [], item_types: new Set() },
                scenarioItems: []
            };
            return;
        }

        if (!currentLesson) return;

        // 2. Языки
        if (trimmed.startsWith('# Lang:')) {
            let langsContent = trimmed.replace('# Lang:', '').trim();
            const langsMatch = langsContent.match(/\[(.*?)\]/);
            if (langsMatch) {
                langsContent = langsMatch[1];
            }
            currentLesson.meta.langs = langsContent.split('/').map(l => l.trim());
            return;
        }

        // 3. Тип секции
        if (trimmed.startsWith('##')) {
            finalizeItem();
            currentType = trimmed.replace('##', '').trim().toLowerCase();
            currentLesson.meta.item_types.add(currentType);
            return;
        }

        // 4. Элемент сценария
        if (trimmed.startsWith('-')) {
            finalizeItem();
            currentItem = {
                type: currentType,
                translations: {},
                tags: []
            };
            currentLesson.scenarioItems.push(currentItem);

            // Add initial text after '-'
            const textAfterDash = trimmed.substring(1).trim();
            if (textAfterDash) {
                pendingTranslations.push(textAfterDash);
            }
            return;
        }

        // 5. Мета-данные элемента
        if (currentItem && trimmed.startsWith('[')) {
            finalizeItem();

            if (trimmed.includes('tags:')) {
                const tagsMatch = trimmed.match(/tags:\s*(.*?)\]/);
                if (tagsMatch) {
                    currentItem.tags = tagsMatch[1].split(',').map(t => t.trim());
                }
            }

            if (trimmed.includes('map:')) {
                const mapMatch = trimmed.match(/map:\s*(.*?)\]/);
                if (mapMatch) {
                    const pairs = mapMatch[1].split(',').map(p => p.trim());
                    currentItem.word_map = pairs.map(pair => {
                        const [src, tgt] = pair.split(':').map(word => word.trim());
                        const entry = {};
                        entry[currentLesson.meta.langs[0]] = src;
                        entry[currentLesson.meta.langs[1]] = tgt;
                        return entry;
                    });
                }
            }
            return;
        }

        // 6. Продолжение перевода
        if (currentItem) {
            pendingTranslations.push(trimmed);
        }
    });

    finalizeItem();
    if (currentLesson && !lessons.includes(currentLesson)) lessons.push(currentLesson);

    // Финализация: Set -> Array
    lessons.forEach(lesson => {
        lesson.meta.item_types = Array.from(lesson.meta.item_types);
    });

    return lessons;
}

export { parseDSL };